export { Button } from './Button';
export { IconCard } from './IconCard';
export { Header } from './Header';
export { HeroSection } from './HeroSection';
export { ValuePropsSection, ENGAGEMENT_ITEMS, WHY_IDENTIO_ITEMS, WHY_IDENTIO_ITEMS_FI, ABOUT_DIFFERENT_ITEMS } from './ValuePropsSection';
export { FeaturedWorkSection } from './FeaturedWorkSection';
export { WorkServicesSection } from './WorkServicesSection';
export { ServicesSection } from './ServicesSection';
export { TechnologySection } from './TechnologySection';
export { TestimonialsSection } from './TestimonialsSection';
export { TeamCultureSection } from './TeamCultureSection';
export { TeamMemberSection } from './team';
export { BlogPreviewSection } from './BlogPreviewSection';
export { BuiltByMentionsSection } from './BuiltByMentionsSection';
export { FinalCTASection } from './FinalCTASection';
export { Footer } from './Footer';
export { CaseStudy } from './CaseStudy';
